import { JobsInfoButton } from './JobsInfoButton';
import { JobsReportButton } from './JobsReportButton';
import { ProgramLifeCycle } from './ProgramsLifeCycle';
import { CreateTemplateButton } from './templates/CreateTemplateButton';
import { isAscendArchivesProduct } from '../../products/utils';
import { hasPermissionToRender } from '@/app/core/utils';
import { getCurrentFeatureCode } from '@/app/core/auth';
import { Link } from 'react-router-dom';
import {
  getAirflowMetaId,
  Job,
  JobStatus,
  ProgramPermissions,
  TemplatesPermissions,
} from '@ssar-app/domain';
import {
  Box,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
  Text,
  Tooltip,
} from '@chakra-ui/react';
import { AiOutlineDown } from 'react-icons/ai/index.js';
import { FaRegClone } from 'react-icons/fa/index.js';
import { usePathContext } from '@ssar-app/okta-authn-react';

interface JobActionsProps {
  record: Job;
  setIsLoading: (arg0: boolean) => void;
  forJobs: boolean;
}

export const JobActions = (props: JobActionsProps) => {
  const { record, setIsLoading, forJobs } = props;
  const { buildPath } = usePathContext();
  const canViewProgramLifeCycle = hasPermissionToRender(
    getCurrentFeatureCode(),
    ProgramPermissions.MayViewProgramLifeCycle,
  );

  return (
    <Box>
      <Menu colorScheme='blackAlpha' placement='bottom-start'>
        <MenuButton
          bg='white'
          py={1}
          px={4}
          border='1px'
          borderColor='gray.300'
          boxShadow='lg'
          borderRadius={'3px'}
          _hover={{
            background: 'white',
            color: 'blue.800',
            borderColor: 'blue.800',
          }}
          _active={{
            background: 'white',
            color: 'blue.800',
            borderColor: 'blue.800',
          }}
        >
          <Flex alignItems='center'>
            Actions <Icon as={AiOutlineDown} ml={1} />
          </Flex>
        </MenuButton>
        <MenuList>
          {record.programId && record.externalSystemRef ? (
            <MenuGroup title='Available Actions'>
              {forJobs && (
                <MenuItem key='info'>
                  <JobsInfoButton
                    record={record}
                    setIsLoading={setIsLoading}
                    forJobs={true}
                  />
                </MenuItem>
              )}
              {hasPermissionToRender(
                getCurrentFeatureCode(),
                ProgramPermissions.MayCreatePrograms,
              ) && (
                <MenuItem key='clone'>
                  <Tooltip
                    placement='left'
                    label='Use as template for new program'
                    hasArrow
                  >
                    <Link
                      to={{
                        pathname: buildPath('/program/create'),
                        search: `from=${record.programId}`,
                        state: { fromDashboard: true },
                      }}
                    >
                      <Flex alignItems='center'>
                        <Icon as={FaRegClone} />
                        <Text ml={1}> Clone Program</Text>
                      </Flex>
                    </Link>
                  </Tooltip>
                </MenuItem>
              )}
              {record?.status === JobStatus.COMPLETED &&
                hasPermissionToRender(
                  getCurrentFeatureCode(),
                  TemplatesPermissions.MayCreateTemplates,
                ) && (
                  <MenuItem key='create-template'>
                    <CreateTemplateButton
                      record={record}
                    ></CreateTemplateButton>
                  </MenuItem>
                )}
              {(isAscendArchivesProduct(record.system) ||
                record?.programMetaId ===
                  getAirflowMetaId(getCurrentFeatureCode() || '')) &&
                record?.status !== JobStatus.VALIDATING && (
                  <MenuItem key='report'>
                    <JobsReportButton
                      record={record}
                      setIsLoading={setIsLoading}
                    ></JobsReportButton>
                  </MenuItem>
                )}
              {canViewProgramLifeCycle && (
                <MenuItem key='lifeCycle'>
                  <ProgramLifeCycle record={record} />
                </MenuItem>
              )}
            </MenuGroup>
          ) : (
            <MenuGroup my={0} title='No Actions available.' />
          )}
        </MenuList>
      </Menu>
    </Box>
  );
};
